<template>
  <v-row row wrap class="mb-3">
    <v-col class="col-4">
      <div
        v-if="types"
        class="text-center hyp-stability-type-bar-btn"
        :class="{
          'hyp-stability-type-bar-btn-active': selected === types.country,
        }"
        @click="toggleType(types.country)"
      >
        <img
          :src="circleLg"
          alt="stability circle large"
          class="hyp-stability-type-bar-img"
        />
        <div
          class="text-center hyp-stability-type-bar-text"
          :class="{
            'hyp-stability-type-bar-text-active': selected === types.country,
          }"
        >
          Country
        </div>
      </div>
    </v-col>
    <v-col class="col-4">
      <div
        v-if="types"
        class="text-center hyp-stability-type-bar-btn"
        :class="{
          'hyp-stability-type-bar-btn-active': selected === types.region,
        }"
        @click="toggleType(types.region)"
      >
        <img
          :src="circleMd"
          alt="stability circle medium"
          class="hyp-stability-type-bar-img hyp-stability-type-bar-img-md"
        />
        <div
          class="text-center hyp-stability-type-bar-text"
          :class="{
            'hyp-stability-type-bar-text-active': selected === types.region,
          }"
        >
          Region
        </div>
      </div>
    </v-col>
    <v-col class="col-4">
      <div
        v-if="types"
        class="text-center hyp-stability-type-bar-btn"
        :class="{
          'hyp-stability-type-bar-btn-active': selected === types.city,
        }"
        @click="toggleType(types.city)"
      >
        <img
          :src="circleSm"
          alt="stability circle small"
          class="hyp-stability-type-bar-img hyp-stability-type-bar-img-sm"
        />
        <div
          class="text-center hyp-stability-type-bar-text"
          :class="{
            'hyp-stability-type-bar-text-active': selected === types.city,
          }"
        >
          City
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import lodashGet from "lodash/get";
import { mapGetters } from "vuex";

import {
  GET_STABILITY_PARAMS,
  SAVE_PREFERENCES,
  GET_STABILITY_REFRESH_MAP,
} from "@/store/actions.type";
import { MODULE_PREFIX_GRIDS, MODULE_PREFIX_USER } from "@/store";
import { buildPreferences } from "@/services/grids/stability.service";
import { GRIDS_STABILITY_TYPES } from "@/common/constants/grids";

export default {
  name: "StabilityTypeBar",
  data: () => ({
    selected: null,
    circleSm: require("@/assets/images/miscellaneous/circle_light_sm.png"),
    circleMd: require("@/assets/images/miscellaneous/circle_light_md.png"),
    circleLg: require("@/assets/images/miscellaneous/circle_light_lg.png"),
  }),
  mounted() {
    this.getPrefs();
  },
  computed: {
    ...mapGetters({
      preferences: MODULE_PREFIX_USER + "preferences",
      stability: MODULE_PREFIX_GRIDS + "stability",
    }),
    types() {
      return GRIDS_STABILITY_TYPES;
    },
  },
  methods: {
    toggleType(type) {
      if (this.selected === type) {
        this.selected = null;
      } else {
        this.selected = type;
      }

      const PREF_PARAMS = buildPreferences({
        preferences: this.preferences,
        type: this.selected,
      });
      this.$store.dispatch(MODULE_PREFIX_USER + SAVE_PREFERENCES, PREF_PARAMS);

      let params = this.stability.params;
      params.type = this.selected;

      this.$store.dispatch(MODULE_PREFIX_GRIDS + GET_STABILITY_PARAMS, params);
      this.$store.dispatch(
        MODULE_PREFIX_GRIDS + GET_STABILITY_REFRESH_MAP,
        true
      );
    },
    getPrefs() {
      if (lodashGet(this.preferences, "grids.stability.type")) {
        this.selected = this.preferences.grids.stability.type;
      } else {
        this.selected = GRIDS_STABILITY_TYPES.country;
      }
    },
  },
  watch: {
    "stability.params": {
      handler() {
        if (this.stability.params) {
          this.selected = this.stability.params.type;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.hyp-stability-type-bar-btn {
  width: 58px;
  height: 74px;
  cursor: pointer;
}
.hyp-stability-type-bar-btn-active {
  border: 1px solid rgba(75, 73, 255, 0.41) !important;
  box-shadow: 0 2px 11px 0 rgba(75, 73, 255, 0.23) !important;
  border-radius: 9px !important;
  background-color: white !important;
}
.hyp-stability-type-bar-img {
  margin: 9px 9px 0 11px;
}
.hyp-stability-type-bar-img-md {
  margin-top: 20px;
}
.hyp-stability-type-bar-img-sm {
  margin-top: 29px;
}
.hyp-stability-type-bar-text {
  color: #1e1e1e;
  font-size: 12px;
}
.hyp-stability-type-bar-text-active {
  color: #4b49ff !important;
  font-weight: 700 !important;
}
</style>
